var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import { useApplicationSession } from '../../services/BillingGatewayServiceHooks';
import styled, { ThemeProvider } from 'styled-components';
import { AsurionDiv } from '../BaseComponents';
import { GlobalStyles } from '@soluto-private/mx-asurion-ui-react';
import { CustomThemeProvider } from '../Theme';
import { PaymentProcessing } from '../PaymentProcessing/PaymentProcessing';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { PaymentSkeleton } from '../PaymentSkeleton/PaymentSkeleton';
import '../../styles/style.css';
import { ExpressPay } from '../ExpressPay/ExpressPay';
import CreditCard from '../CreditCard/CreditCard';
import { Locale } from '../../common/Constants';
export var PaymentUIWrapper = styled(AsurionDiv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    max-width: 774px;\n    min-width: 296px;\n    min-height: 400px;\n    margin: 0 auto;\n    position: relative;\n"], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    max-width: 774px;\n    min-width: 296px;\n    min-height: 400px;\n    margin: 0 auto;\n    position: relative;\n"])), function (props) { return props.theme.fieldGap; });
var ThreeDSecureActionContainer = styled(AsurionDiv)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    position: absolute; /* Use absolute positioning within the parent */\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    z-index: 2;\n\n    background-color: rgba(255, 255, 255, 0.95);\n    backdrop-filter: grayscale(1) blur(1px);\n\n    &:empty {\n        display: none;\n    }\n\n    & iframe {\n        width: 390px;\n        height: 400px;\n        background-color: white;\n        border: #ccc 1px solid;\n        box-sizing: border-box;\n        border-radius: 5px;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    position: absolute; /* Use absolute positioning within the parent */\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n\n    z-index: 2;\n\n    background-color: rgba(255, 255, 255, 0.95);\n    backdrop-filter: grayscale(1) blur(1px);\n\n    &:empty {\n        display: none;\n    }\n\n    & iframe {\n        width: 390px;\n        height: 400px;\n        background-color: white;\n        border: #ccc 1px solid;\n        box-sizing: border-box;\n        border-radius: 5px;\n    }\n"])));
export var PaymentUI = forwardRef(function (props, ref) {
    var creditCardRef = useRef(null);
    var _a = React.useState(false), isPaymentProcessing = _a[0], setIsPaymentProcessing = _a[1];
    var locale = props.locale || Locale.US;
    var _b = React.useState(undefined), errorDetails = _b[0], setErrorDetails = _b[1];
    var _c = React.useState(false), isExpressPayOptionsAvailable = _c[0], setIsExpressPayOptionsAvailable = _c[1];
    var _d = React.useState(false), isCreditCardInitialized = _d[0], setCreditCardInitialized = _d[1];
    useImperativeHandle(ref, function () {
        return {
            continue: function () {
                var _a;
                if ((_a = creditCardRef === null || creditCardRef === void 0 ? void 0 : creditCardRef.current) === null || _a === void 0 ? void 0 : _a.continue) {
                    creditCardRef.current.continue();
                }
            }
        };
    }, []);
    var applicationSession = useApplicationSession(props.billingGatewayService, props.applicationSession, props.onPaymentSuccess, props.onPaymentFailure, setIsPaymentProcessing, setErrorDetails, locale);
    var threedsActionContainerRef = useRef(null);
    useEffect(function () {
        var _a, _b;
        if (applicationSession === undefined) {
            (_a = props.onLoading) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        else {
            (_b = props.onLoaded) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [applicationSession]);
    var submitPaymentForm = function (authPaymentInfo, actionHandler) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (authPaymentInfo === undefined) {
                        return [2 /*return*/];
                    }
                    (_a = props.onPaymentProcessing) === null || _a === void 0 ? void 0 : _a.call(props);
                    return [4 /*yield*/, (applicationSession === null || applicationSession === void 0 ? void 0 : applicationSession.submitPaymentForm(authPaymentInfo, threedsActionContainerRef, setErrorDetails, actionHandler))];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var isPaymentOptionsInitialized = function () {
        return isExpressPayOptionsAvailable && isCreditCardInitialized;
    };
    if (!applicationSession) {
        return (React.createElement(React.Fragment, null,
            React.createElement(GlobalStyles, null),
            React.createElement(ThemeProvider, { theme: CustomThemeProvider(props.styleOverride) },
                React.createElement(PaymentUIWrapper, null,
                    React.createElement(PaymentSkeleton, null)))));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyles, null),
        React.createElement(ThemeProvider, { theme: CustomThemeProvider(props.styleOverride) },
            React.createElement(PaymentUIWrapper, null,
                !isPaymentOptionsInitialized() && React.createElement(PaymentSkeleton, null),
                isPaymentProcessing && React.createElement(PaymentProcessing, { locale: locale }),
                React.createElement(ThreeDSecureActionContainer, { ref: threedsActionContainerRef }),
                React.createElement(ExpressPay, { applicationSession: applicationSession, onAuthorized: submitPaymentForm, locale: locale, onProcessing: setIsPaymentProcessing, isExpressPayOptionsAvailable: setIsExpressPayOptionsAvailable }),
                React.createElement(ErrorMessage, { error: errorDetails, onClose: function () { return setErrorDetails(undefined); }, locale: locale }),
                React.createElement(CreditCard, { applicationSession: applicationSession, onSubmit: submitPaymentForm, locale: locale, vendor: applicationSession.vendor, existingBillingInformation: props.billingInformation, existingCardholderName: props.cardholderName, ref: creditCardRef, hideContinueButton: props.hideContinueButton, onCreditCardFormValid: props.onCreditCardFormValid, onPaymentFailure: props.onPaymentFailure, onProcessing: setIsPaymentProcessing, onCreditCardInitialized: function () { return setCreditCardInitialized(true); } })))));
});
var templateObject_1, templateObject_2;
